<script setup lang="ts">
import { computed, ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { getCurrentUser } from '@/composables/user/users'
import { useLocalStorage } from '@vueuse/core'
import { STORAGE_KEY_MEMORIZE_THANK_CONTENT } from '@/constants'
import { ElMessage } from 'element-plus'
const { t } = useI18n()
const memorizeThankContent = useLocalStorage(STORAGE_KEY_MEMORIZE_THANK_CONTENT, '')
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  messageName: {
    type: String,
    default: ''
  },
  messageId: {
    type: String,
    default: ''
  }
})
const messageName = computed(() => {
  return props.messageName
})
const messageId = computed(() => {
  return props.messageId
})

const showThankDialog = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

onMounted(() => {
  const select = document.querySelector('.el-select') as HTMLElement
  console.log('select', select)
  // select.__vue__.visible = true;
})
const thankContentList = [
  '感谢各位亲友前来送别，这份心意我们全家铭记于心，谢谢大家！',
  '承蒙各位关心慰问，不胜感激，愿大家平安顺遂！',
  '感谢大家的送别与帮助，这份情谊我们永远珍藏，谢谢！'
]

const showThankContentList = ref(false)
const toggleThankContentList = () => {
  showThankContentList.value = !showThankContentList.value
}

const selectThankContent = (content: string) => {
  thankContent.value = content
  showThankContentList.value = false
}

const emit = defineEmits(['update:modelValue', 'onSentThank'])
const thankContent = ref()
const selectedThank = ref()
const sendName = ref(getCurrentUser().value?.user?.name?.fullName || '')
const isAgree = ref(false)
watch(showThankDialog, (newValue) => {
  if (newValue) {
    thankContent.value = memorizeThankContent.value
  }
})
memorizeThankContent.value
// 监听selectedThank的变化，当选择了下拉选项时，更新thankContent
watch(selectedThank, (newValue) => {
  if (newValue) {
    thankContent.value = newValue
  }
})
watch(isAgree, (newValue) => {
  if (newValue) {
    sendName.value = ''
  } else {
    sendName.value = getCurrentUser().value?.user?.name?.fullName || ''
  }
})

const handleThank = () => {
  if (!thankContent.value.trim()) {
    ElMessage.error(t('obituary.please_input_thank_content'))
    return
  }

  if (!sendName.value.trim()) {
    ElMessage.error(t('obituary.please_input_send_name'))
    return
  }

  memorizeThankContent.value = thankContent.value

  emit('onSentThank', thankContent.value, sendName.value, messageId.value)
  // 重置并关闭对话框
  thankContent.value = ''
  isAgree.value = false
  showThankDialog.value = false
}

const optionRef = ref<HTMLElement[]>([])
</script>
<template>
  <el-dialog v-model="showThankDialog" w-100 rounded-2 :lock-scroll="true" class="ThankDialog">
    <div w-full flex flex-col justify-center items-center px-2>
      <div text-center text-xl font-bold mt--4>{{ t('obituary.host_thank') }}</div>
      <div w-full>
        <div text-main mt-2>{{ t('m.thank_to', { name: messageName }) }}:</div>
        <div relative w-full mt-2>
          <textarea
            w-full
            class="textarea"
            v-model="thankContent"
            :placeholder="t('obituary.please_input_thank_content1')"
            rounded-1
            input-base
            min-h-60
            p-4
            pb-8
            maxlength="140"
            style="resize: none"
            text-lg></textarea>
          <!-- 字数统计 - 左下角 -->
          <div absolute bottom-4 left-4 text-sm text-third>{{ thankContent.length }}/140</div>
          <!-- 常用答谢词下拉菜单 - 右下角 -->
          <div
            absolute
            bottom-4
            right-4
            text-sm
            text-main
            cursor-pointer
            flex
            items-center
            @click="toggleThankContentList">
            <span mr-1 text-base>常用答谢词</span>
            <i class="el-icon inline-block" :class="showThankContentList ? 'i-ep-arrow-up' : 'i-ep-arrow-down'"></i>
          </div>
          <!-- 下拉菜单 -->
          <div
            v-if="showThankContentList"
            absolute
            top-full
            right-0
            mt-1
            bg-white
            border
            rounded-lg
            shadow-lg
            w-80
            z-10
            overflow-hidden>
            <div
              v-for="(item, index) in thankContentList"
              :key="index"
              p-3
              hover:bg-gray-50
              cursor-pointer
              text-main
              border-b
              border-gray-100
              last:border-0
              @click="selectThankContent(item)"
              transition-colors
              duration-200>
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div flex justify-between items-center w-full mt-2>
        <div flex justify-start items-center>
          <el-checkbox v-model="isAgree" size="large" style="color: #000000"></el-checkbox>
          <div text-sm text-main ml-2>{{ t('obituary.send_by_other') }}</div>
        </div>
        <div flex justify-start items-center>
          <div text-main text-base>{{ isAgree ? t('open_life.host_name') : t('open_life.send_name') }}</div>
          <input type="text" v-model="sendName" input-base ml-1 maxlength="24" w-40 />
        </div>
      </div>
      <div w-full flex justify-center items-center mt-8>
        <button btn-solid rounded-1 min-w-20 w-60 @click="handleThank" cursor-pointer>{{ t('m.sent_thank') }}</button>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped></style>
